class FetchAccountLogo {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAccountLogo;
